import { gql } from "lib/apolloClient";

export const attachmentFragment = {
  attachment: gql`
    fragment attachmentItemV2 on Attachment {
      id
      name
      type
      mimeType
      url
      signedUrl
      thumbUrl
      title
      createdBy {
        id
        firstName
        middleName
        type
        lastName
        profileImage
      }
    }
  `,
};

export const organizationResourceFragment = {
  organizationResourceV2: gql`
    fragment organizationResourceItemV2 on OrganizationResource {
      id
      label
      attachment {
        ...attachmentItemV2
      }
      type
      resourceType
    }
    ${attachmentFragment.attachment}
  `,
  organizationResourceV3: gql`
    fragment organizationResourceItemV3 on OrganizationResource {
      id
      label
      attachment {
        ...attachmentItemV2
      }
      type
      resourceType
      item {
        ... on OrganizationResource {
          id
          label
          isImported: isImportedFromDiffOrg
          attachment {
            ...attachmentItemV2
          }
          isDeleted
          type
          resourceType
          visibleTo
        }
        ... on Assessment {
          id
          isImported
          title {
            id
            value
          }
          assessmentType {
            id
            value
          }
          image {
            id
            value
          }
          grades {
            id
            name
          }
          createdBy {
            id
            firstName
            lastName
            profileImage
          }
        }
      }
    }
    ${attachmentFragment.attachment}
  `,
};

export const organizationResourceFeedFragment = {
  unitPlanResourceFeedV2: gql`
    fragment unitPlanResourceFeedItemV2 on UnitPlan {
      id
      organizationResourcesConnection(
        searchText: $searchText
        after: $after
        first: 12
      ) {
        edges {
          node {
            ...organizationResourceItemV2
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        resourceTypeBasedCount {
          totalCount
        }
      }
    }
    ${organizationResourceFragment.organizationResourceV2}
  `,
};

export const organizationChildResourceFragment = {
  childResourceFragmentV2: gql`
    fragment organizationChildResourceItemV2 on OrganizationResource {
      id
      label
      children: childrenV2(
        first: $first
        after: $after
        orderBy: $orderBy
        orderByDirection: $orderByDirection
        filters: $filters
      ) {
        resourceTypeBasedCount {
          folderCount
          fileCount
        }
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...organizationResourceItemV3
          }
        }
      }
      isDeleted
      visibleTo
      resourceType
      parentHierarchy {
        id
        label
      }
    }
    ${organizationResourceFragment.organizationResourceV3}
  `,
};
